module.exports = __webpack_public_path__ + "static/media/dj4b-drown-art.bd254fa0.png";